import { makeStyles } from '@material-ui/styles';

export const styles = makeStyles(({ theme }) => ({
  root: {
    width: '455px',
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '& .MuiFormLabel-asterisk.MuiInputLabel-asterisk': {
      color: 'red',
    },
  },
  editProgramInput: {
    width: '100%',
    marginBottom: '20px',
    '& .MuiInputBase-input': {
      fontWeight: '700',
      fontSize: '0.875rem',
      color: '#152C73',
    },
  },
  programNameInputValidation: {
    marginTop: '-13px',
    fontFamily: 'inherit',
    fontSize: '12px',
    color: 'red',
  },
}));
